import { useLanguage } from 'features/hooks/useLanguage';
import { LanguageType } from 'types';

export const OpenCodelistSection = () => {
	const language = useLanguage();
	const translation = DICTIONARY[language];

	return (
		<div className="flex flex-col gap-4">
			<p className="text-base">{translation.description}</p>

			<img
				className="mt-6 w-[90%] object-cover self-center"
				src="/img/codelist-changelog/open-codelist.gif"
				alt={translation.imgAlt}
			/>
		</div>
	);
};

const DICTIONARY = {
	[LanguageType.English]: {
		imgAlt: 'A gif showing how to open the codelist sidebar',
		description:
			'You may access the codelist sidebar when you are creating or updating an entry.'
	},

	[LanguageType.Norwegian]: {
		imgAlt: 'En gif som viser hvordan man åpner kodelisten',
		description:
			'Du kan aksessere kodelisten i sidemenyen når du oppretter eller oppdaterer en oppføring.'
	}
};
